import * as v from "valibot";
import { MAX_COLLECTION_NAME_LENGTH } from "../collections";
import { articleKey, MAX_ID_LENGTH } from "./shared.dto";

const idField = v.pipe(v.string(), v.minLength(1), v.maxLength(MAX_ID_LENGTH));
const nameField = v.pipe(v.string(), v.minLength(1), v.maxLength(MAX_COLLECTION_NAME_LENGTH));

export const collectionDto = v.object({
  id: v.string(),
  name: v.string(),
  isDefault: v.boolean(),
  articleCount: v.number(),
  createdAt: v.number(),
  updatedAt: v.number(),
});
export type CollectionDto = v.InferOutput<typeof collectionDto>;

export const listCollectionsResponse = { collections: v.array(collectionDto) };

export const createCollectionRequest = { name: nameField };
export const createCollectionResponse = { collection: collectionDto };

export const updateCollectionRequest = { id: idField, name: nameField };

export const deleteCollectionRequest = { id: idField };

export const copyCollectionRequest = { id: idField, targetCollectionId: idField };
export const copyCollectionResponse = {
  numArticlesCopied: v.number(),
  /** False when the target collection filled up before every article was copied. */
  copiedAll: v.boolean(),
};

/** Adds (PUT) or removes (DELETE) an article of a collection. */
export const collectionArticleRequest = { id: idField, ...articleKey };
export const putCollectionArticleResponse = {
  /** False when the collection already held the article. */
  added: v.boolean(),
};

export const getArticleCollectionsRequest = articleKey;
export const getArticleCollectionsResponse = { collectionIds: v.array(v.string()) };

export const getBookmarkedArticlesResponse = {
  /** "authorAlias:articleId" to the ids of the collections that hold it. */
  articleCollections: v.record(v.string(), v.array(v.string())),
};
